import React, { useEffect, useRef, useState } from 'react';
import { useGlobalState } from '../../state/GlobalStateProvider';
import './StepTooltip.scss';

const Tooltip = ({ steps, onComplete }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [{ user }] = useGlobalState();
  const [tooltipPosition, setTooltipPosition] = useState({});
  const tooltipRef = useRef(null);
  const alreadyDone = localStorage.getItem(`mint_flow_steps_completed_${user?.address}`);

  useEffect(() => {
    if (steps[currentStep]?.targetRef?.current && tooltipRef.current) {
      const targetElement = steps[currentStep].targetRef.current.getBoundingClientRect();
      const tooltipWidth = tooltipRef.current.offsetWidth;
      const tooltipHeight = tooltipRef.current.offsetHeight;
  
      // Get the offset of the closest relatively positioned ancestor
      const offsetParent = tooltipRef.current.offsetParent;
      const parentRect = offsetParent ? offsetParent.getBoundingClientRect() : { top: 0, left: 0 };
  
      // Calculate tooltip position relative to the offset parent
      setTooltipPosition({
        top: targetElement.top + window.scrollY - tooltipHeight - 40,
        left: targetElement.left + (targetElement.width / 2) - (tooltipWidth / 2) - parentRect.left,
      });
    }
  }, [currentStep, steps]);

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(prev => prev + 1);
    } else {
      if (onComplete) onComplete();
      setCurrentStep(-1);
    }
  };

  if (currentStep < 0 || currentStep >= steps.length || alreadyDone || !user) return <></>;

  return (
    <>
      {currentStep < steps.length && (
        <div
          className='step_tooltip border_animation'
          ref={tooltipRef}
          style={{
            position: 'absolute',
            top: tooltipPosition.top || 0,
            left: tooltipPosition.left || 0,
          }}
        >
         
          <div className='step_tooltip_path'>
            <svg xmlns='http://www.w3.org/2000/svg' width='48' height='13' viewBox='0 0 48 13' fill='none'>
              <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M0.5 0.00194926C2.21249 0.00194926 3.92448 -0.00655092 5.63697 0.0119495C7.27598 0.0299499 9.11044 0.0554504 10.7055 0.656963C12.4284 1.30698 13.5691 2.4435 14.7168 3.78103C15.543 4.74305 17.166 6.79559 17.9563 7.78661C18.6031 8.59913 19.8692 10.2052 20.5605 10.9822C21.4308 11.9597 22.5064 12.9987 24.0005 12.9987C25.4946 12.9987 26.5697 11.9597 27.4395 10.9832C28.1308 10.2067 29.3969 8.59963 30.0442 7.78761C30.8335 6.79659 32.4565 4.74405 33.2832 3.78203C34.4329 2.4445 35.5716 1.30798 37.294 0.657963C38.8896 0.0579504 40.7245 0.0309499 42.3625 0.0129495C44.0755 -0.0055509 45.7875 0.00294928 47.5 0.00294928'
                fill='#fff'
                fill-opacity='1'
              />
            </svg>
          </div>
          <p>{steps[currentStep].content}</p>
          <button onClick={handleNext}>{currentStep < steps.length - 1 ? 'Next' : 'Finish'}</button>
        </div>
      )}
    </>
  );
};

export default Tooltip;
